/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createTransactionsGetResponseFromDiscriminatorValue, type TransactionsGetResponse } from '../../../../../models';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /accounts/{accountId}/upcomingtransactions/{cycleIndex}/{cycleCount}
 */
export interface WithCycleCountItemRequestBuilder extends BaseRequestBuilder<WithCycleCountItemRequestBuilder> {
    /**
     * Retrieves upcoming transactions for a specified account
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<TransactionsGetResponse[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<TransactionsGetResponse[] | undefined>;
    /**
     * Retrieves upcoming transactions for a specified account
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithCycleCountItemRequestBuilderUriTemplate = "{+baseurl}/accounts/{accountId}/upcomingtransactions/{cycleIndex}/{cycleCount}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithCycleCountItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithCycleCountItemRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createTransactionsGetResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
